import { includes } from "lodash";
import { Platform as RootPlatform } from "@linkfluence/models/platform";

export const CorporaPlatform = {
  Twitter: RootPlatform.Twitter,
  Facebook: RootPlatform.Facebook,
  Instagram: RootPlatform.Instagram,
  Sinaweibo: RootPlatform.Sinaweibo,
  Youtube: RootPlatform.Youtube,
  Twitch: RootPlatform.Twitch,
  Pinterest: RootPlatform.Pinterest,
  Review: RootPlatform.Review,
  Critizr: "critizr",
  Web: "web",
  Feed: RootPlatform.Feed,
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type CorporaPlatform =
  typeof CorporaPlatform[keyof typeof CorporaPlatform];

export function isACorporaWebPlatform(platform: CorporaPlatform): boolean {
  return includes(
    [
      CorporaPlatform.Review,
      CorporaPlatform.Critizr,
      CorporaPlatform.Feed,
      CorporaPlatform.Web,
    ],
    platform
  );
}

export interface CorporaSocialSource {
  id: string;
  label: string;
  screenName: string;
  credentialId?: string;
}

export interface CorporaWebSource {
  url: string;
  label?: string;
}

export type CorporaSource = CorporaSocialSource | CorporaWebSource;

export type CorporaTotalSourcesByPlatform = {
  [corpusName: string]: {
    [platform: string]: number;
  };
};
